<template>
    <v-col>
        <v-col
            v-if="downloading"
            class="subtitle-1 text-center"
            cols="12"
            > Cargando por favor espere...
        </v-col>
        <v-progress-linear
            indeterminate
            :background-color="backgroundLoadingColor"
            :color="loadingColor"
            height="10"
            v-if="downloading"
        ></v-progress-linear>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :loading="loading"
            loading-text="Cargando..."
            :class="`elevation-1 ${navbarColor}`"
            item-key="id"
            :footer-props="footerOptions"
        >
            <template v-slot:item.actions="{ item }">
                <slot
                    v-if="hasActionsSlot()"
                    name="actions"
                    :item="item"
                />
            </template>
        </v-data-table>
    </v-col>
</template>

<script>
import { mapGetters } from 'vuex';
import * as _ from 'underscore';

export default {
    props: {
      headers: {
        type: Array,
        required: true,
      },
      apiURL: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      readonly: {
        type: Boolean,
        required: false,
        default: false,
      },
      readonlyDate: {
        type: Boolean,
        required: false,
        default: false,
      },
      back: {
        type: Boolean,
        required: false,
        default: false,
      },
      backURL: {
        type: String,
        required: false,
      },
      queryParams: {
        type: String,
        required: false,
        default: '',
      },
      message: { default: '' },
      type: { default: '' },
      bus: { default: null },
      refresh: { default: false },
    },
    data: () => ({
      downloading: false,
      busy: false,
      loading: false,
      dialog: false,
      dialogStatus: false,
      dialogFolios: false,
      dialogShowEmail: false,
      dialogCancelDoc: false,
      dialogApplyRet: false,
      reason: '',
      total_amount_taxed: '',
      total_amount_tax: '',
      total_amount: '',
      dateAnnulment: '',
      editedIndex: -1,
      options: {},
      search: '',
      items: [],
      totalItems: 0,
      footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
      toggleStatus: false,
      toggleStatusFolios: false,
      deleteID: '',
      issue_date: '',
      item: null,
      menu2: false,
      noReload: false,
    }),
    watch: {
      options: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      search: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      apiURL: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
      queryParams: {
        handler() {
          this.refreshTable();
        },
        deep: true,
      },
    },
    computed: {
      ...mapGetters({
        loadingColor: 'theme/loadingColor',
        backgroundLoadingColor: 'theme/backgroundLoadingColor',
        navbarColor: 'theme/navbarColor',
      }),
    },
    mounted() {
      if (this.bus) this.bus.$on('refreshTable', this.refreshTable);
    },
    methods: {
      debounceInput: _.debounce(function d(e) {
        this.search = e;
      }, 500),
      hasActionsSlot() {
        return !!this.$scopedSlots.actions;
      },
      refreshTable() {
        this.getDataFromApi()
        .then((data) => {
          this.items = data.items;
          this.totalItems = data.total;
        });
      },
      getDataFromApi() {
        this.downloading = true;
        this.loading = true;
        return new Promise(async (resolve) => {
          const {
            sortBy,
            sortDesc,
            page,
            itemsPerPage,
          } = this.options;
          const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
              const data = response.data.items;
              const { total } = response.data;
              return ({ data, total } || []);
          });
          const items = response.data;
          const { total } = response;

          setTimeout(() => {
            this.loading = false;
            this.downloading = false;
            resolve({
              items,
              total,
            });
          }, 1000);
        });
      },
      getItems(page, itemsPerPage, sortBy, sortDesc) {
        const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
        &search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
        const promise = window.axios.get(url).then();
        return promise;
      },
      getColor(status) {
        if (status.indexOf('1') !== -1) return 'green';
        return 'red';
      },
      reload() {
        this.noReload = true;
        this.refreshTable();
        setTimeout(() => {
          this.noReload = false;
        }, 7500);
      },
    },
};
</script>

<style>

</style>
